export default  {
  "firstName": "XRMGBV",
  "middleName": "I",
  "lastName": "LH3EPBCDPVN",
  "age": "540726",
  "gender": " ",
  "fullName": "XRMGBV I LH3EPBCDPVN",
  "rpsIndividualIdentifier": "6361e4ec-dafe-4c69-bcf0-544761fe6bc2",
  "sdaElig": false,
  "sdaEnrollmentEligible": true,
  "postalAddress": {
    "addressLine1": "4515 PAINTERS MILL ROAD",
    "addressLine2": "4515 PAINTERS MILL ROAD",
    "addressLine3": "",
    "city": "ALABASTER",
    "state": "AL",
    "zipCode9": "35007"
  },
  "enrolledInMorningStar": false,
  "enrolledInFEI": false,
  "enrolledInFEIPlus": null,
  "enrolledInMPI": false,
  "status": "04",
  "birthDate": "1968-10-12T04:00:00.000+00:00",
  "tenure": 0,
  "tenureMonths": 0,
  "autoEnrollmentGracePeriodEndDate": "2023-06-17 04:00:00.000+0000",
  "autoEnrollmentStatus": "P",
  "enrollmentDate": "2023-05-18T04:00:00.000+00:00",
  "newEnrollee": false,
  "hasCommittedEnrollment": true,
  "hasPendingEnrollment": false,
  "dateEligible": "2019-07-01T04:00:00.000+00:00",
  "statusDesc": "ELIGIBLE/NONPAR",
  "ageYears": "54",
  "ageMonths": "07",
  "ageDays": "26",
  "payFrequency": 6,
  "salaryDefCapCode": null,
  "deceased": false,
  "planEntryDate": "2019-11-27T05:00:00.000+00:00",
  "hireDate": "2019-05-30T04:00:00.000+00:00",
  "postTaxBasis": 0.0,
  "terminationReasonCode": null,
  "terminationDate": null,
  "beneficiary": false,
  "clientEmployeeId": "LH3",
  "participantStatus": "03",
  "smartVideoEnrollmentDate": "2023-05-18T04:00:00.000+00:00",
  "validateForFraudCSuite": false,
  "hasCurrentDeferral": false,
  "firstEmployeeContributionSummaryDate": null,
  "earliestContributionStartDate": "2016-01-29T05:00:00.000+00:00",
  "terminated": false,
  "particRMDEligible": false,
  "catchUpEligible": true,
  "highComp": false,
  "addressPOBox": false,
  "fiftyNineAndHalf": false,
  "selfDirectedAccountEnrollmentEligible": true,
  "selfDirectedAccountEligible": false
}
